import { NewCustomerResponse } from "Store/userIdentification/userIdentificationInterfaces";
import { isDefined } from "Utils/functions";
import React from "react";

interface Props {
  newCustomerResponse: NewCustomerResponse;
}

export const UserName = ({
  newCustomerResponse,
}: Props): React.ReactElement | null => {
  if (!isDefined(newCustomerResponse.providedPersonInfo.name)) {
    return null;
  }
  const { firstName, lastName } = newCustomerResponse.providedPersonInfo.name;

  return <p>{`${firstName} ${lastName}`}</p>;
};
